import type { ReviewKind } from '../types';

export const GRID_TEMPLATE = '2fr 1.4fr 1.2fr 0.9fr 1fr 170px';

export const DISMISSED_STORAGE_KEY = 'novala.archiveDismissed';
export const ARCHIVED_STORAGE_KEY = 'novala.archivedAccounts';

export function approveAllEventName(kind: ReviewKind): string {
  return `novala:review-${kind}-approve-all`;
}

export function dismissAllEventName(kind: ReviewKind): string {
  return `novala:review-${kind}-dismiss-all`;
}